import type { AssistantToolCall } from '../../api/types';
import { RichText } from './RichText';
import { ToolCallList } from './ToolCallList';

/** Un turno ya cerrado de la conversacion. */
export interface ChatTurn {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  toolCalls?: AssistantToolCall[];
}

export function ChatBubble({ turn }: { turn: ChatTurn }): JSX.Element {
  const isUser = turn.role === 'user';

  return (
    // El id permite que la pagina baje al PRINCIPIO de este mensaje cuando
    // aparece; el margen de scroll lo aparta de la barra superior fija.
    <article id={`turno-${turn.id}`} className={`bubble bubble--${isUser ? 'user' : 'alexia'}`}>
      <p className="bubble__who">{isUser ? 'Tú' : 'Alexia'}</p>
      <div className="bubble__body">
        {isUser ? <p className="rich__p">{turn.content}</p> : <RichText text={turn.content} />}
      </div>
      {!isUser && <ToolCallList calls={turn.toolCalls ?? []} />}
    </article>
  );
}
